/**
 * defa.routers.BaseRouter
 * Main router for any random or external simplify resource.
 * @version 1.2.0
 */

const BaseRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'(/)'      : 'showHome',
		'validate/:validationCode(?:query)(/)': 'validateEmail',
		'konami(/)': 'konami',
		
		// external resources
		'external/downloads(/)': 'showDownloads',
		'external/manuals(/)'  : 'showManuals',
		'external/tsp(/)'      : 'showTSPortal',
		'external/acp(/)'      : 'showACPortal',
		'external/dtp(/)'      : 'showDTPortal',
		
		// fallback error:
		'*notFound': 'showFallback',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	
} );

export default BaseRouter;